import images from "./images";
import {
  GiPartyPopper,
  GiBallerinaShoes,
  GiPartyFlags,
  GiMusicalNotes,
} from "react-icons/gi";
import { IoDiamondSharp } from "react-icons/io5";
import { MdOutlineWorkspacePremium } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi2";
import { IoFitnessSharp } from "react-icons/io5";
import {
  FaEnvelopeOpen,
  FaMapMarkerAlt,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";

interface Service {
  id: number;
  icon: JSX.Element;
  title?: string;
  text?: string;
}

interface About {
  id: number;
  text: string;
}

interface Quality {
  id: number;
  title: string;
  text: string;
}

interface Quality {
  id: number;
  icon: JSX.Element;
  title: string;
  text: string;
}

interface Feature {
  id: number;
  title: string;
  text: string;
}

interface PortfolioItem {
  id: number;
  title: string;
  text: string;
  image: string;
}

interface Testimonial {
  id: number;
  name: string;
  text: string;
  image: string;
  rating: number;
}

interface ContactInfo {
  id: number;
  icon: JSX.Element;
  info: string;
  text: string;
}

interface Pricing {
  id: number;
  name: string;
  price: string;
  time: string;
  image: string;
  content: string[];
}

interface PrivacyPolicy {
  title: string;
  content: string;
  address: string;
  email: string;
  sections: PrivacyPolicySection[];
  lastUpdated: string;
}

interface PrivacyPolicySection {
  title: string;
  content: string;
}

interface Regulation {
  title: string;
  content: string;
  sections: RegulationSection[];
  lastUpdated: string;
}

interface RegulationSection {
  title: string;
  content: string[];
}

interface Sections {
  services: Service[];
  about: About[];
  qualities: Quality[];
  features: Feature[];
  portfolio: PortfolioItem[];
  testimonials: Testimonial[];
  contact: ContactInfo[];
  pricing: Pricing[];
  privacyPolicy: PrivacyPolicy;
  regulation: Regulation;
}

const gradient: string = "url(#blue-gradient)";

const services: Service[] = [
  {
    id: 1,
    icon: <IoDiamondSharp style={{ fill: gradient }} />,
    title: "Lecciones privadas",
    text: "Diseñadas para aquellos que desean una atención individualizada y personalizada para mejorar sus habilidades de baile y alcanzar sus objetivos específicos.",
  },
  {
    id: 2,
    icon: <HiUserGroup style={{ fill: gradient }} />,
    title: "Grupos de Baile",
    text: "Ofrecen una experiencia dinámica y colaborativa, donde los estudiantes pueden aprender y crecer juntos mientras comparten su pasión por el baile en un ambiente divertido y motivador.",
  },
  {
    id: 3,
    icon: <IoFitnessSharp style={{ fill: gradient }} />,
    title: "Dance Fitness",
    text: "Donde fusionamos movimientos de baile con ejercicios cardiovasculares para brindarte una experiencia de ejercicio completa y estimulante.",
  },
  {
    id: 4,
    icon: <GiPartyPopper style={{ fill: gradient }} />,
    title: "Quince años",
    text: "Nuestros servicios personalizados de coreografía y entrenamiento te ayudarán a brillar en tu fiesta de quinceañera con pasos de baile que reflejen tu personalidad única y hagan de tu día especial una experiencia verdaderamente inolvidable.",
  },
  {
    id: 5,
    icon: <GiPartyFlags style={{ fill: gradient }} />,
    title: "Talleres enfocados",
    text: "Ofrecemos talleres de baile enfocados diseñados para ayudarte a perfeccionar habilidades específicas, explorar nuevos estilos o profundizar en técnicas avanzadas.",
  },
  {
    id: 6,
    icon: <GiMusicalNotes style={{ fill: gradient }} />,
    title: "Sociales",
    text: "Nuestros sociales son la ocasión perfecta para que nuestros estudiantes y la comunidad del baile se reúnan, se diviertan y celebren su amor por el baile.",
  },
];

const about: About[] = [
  {
    id: 7,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris finibus leo et diam fermentum ullamcorper. Nulla venenatis nibh sollicitudin tincidunt gravida. Nam convallis justo et ligula luctus suscipit. Etiam eu nisi turpis. Donec sollicitudin accumsan quam, rhoncus sagittis metus semper quis. Praesent convallis mauris sed ipsum lobortis facilisis. Nulla cursus sem non nunc sagittis, a volutpat mauris lobortis. Nulla ut feugiat tellus. Nam dictum nisi nec scelerisque auctor",
  },
];

const qualities: Quality[] = [
  {
    id: 8,
    icon: <MdOutlineWorkspacePremium style={{ fill: gradient }} />,
    title: "Inscripción",
    text: "$1,800.00",
  },
  {
    id: 9,
    icon: <GiBallerinaShoes style={{ fill: gradient }} />,
    title: "Costo unitario por clase",
    text: "$200.00",
  },
];

const features: Feature[] = [
  {
    id: 10,
    title: "¿Puedo tomar clases individuales o en grupo?",
    text: "Sí, ofrecemos tanto clases individuales como en grupo para adaptarnos a tus preferencias y necesidades de aprendizaje.",
  },
  {
    id: 11,
    title: "¿Quiénes son los profesores de ML Dance Studio?",
    text: "Nuestro equipo de profesores está formado por artistas altamente cualificados y apasionados, cada uno experto en su género específico de baile.",
  },
  {
    id: 12,
    title: "¿Ofrecen clases para principiantes?",
    text: "Sí, ofrecemos clases diseñadas específicamente para principiantes en cada uno de nuestros estilos de baile. Nuestros profesores están capacitados para ayudarte a dar tus primeros pasos en el mundo del baile con confianza y habilidad.",
  },
  {
    id: 13,
    title: "¿Tienen instalaciones adecuadas para bailar?",
    text: "Por supuesto, en ML Dance Studio contamos con tres pistas de baile especialmente diseñadas para ofrecer el espacio y la comodidad necesarios para practicar y disfrutar del baile en un ambiente inspirador.",
  },
  {
    id: 14,
    title:
      "¿Hay oportunidades para presentaciones o espectáculos en ML Dance Studio?",
    text: "Sí, organizamos eventos especiales y espectáculos donde nuestros estudiantes tienen la oportunidad de mostrar sus habilidades y talento en el escenario. También ofrecemos clases y entrenamiento para aquellos que estén interesados en participar en presentaciones.",
  },
  {
    id: 15,
    title:
      "¿Cómo puedo ponerme en contacto con ML Dance Studio si tengo más preguntas?",
    text: "Puedes ponerte en contacto con nosotros a través de nuestro sitio web, por teléfono o correo electrónico. Estamos aquí para ayudarte y responder a todas tus preguntas sobre nuestras clases y servicios.",
  },
];

const portfolio: PortfolioItem[] = [
  {
    id: 16,
    title: "Mindfulness",
    text: "Experimenta la calma y la conexión con tu cuerpo a través de movimientos conscientes fluidos en el baile y la meditación.",
    image: images.portfolio_img_1,
  },
  {
    id: 17,
    title: "Zumba",
    text: "Sumérgete en la pasión y el ritmo contagioso de los bailes latinos mientras te mueves al son de la música.",
    image: images.portfolio_img_2,
  },
  {
    id: 18,
    title: "Ballet",
    text: "Descubre la elegancia y la gracia en cada paso mientras exploras la belleza atemporal del ballet clásico.",
    image: images.portfolio_img_3,
  },
  {
    id: 1600,
    title: "Hip Hop",
    text: "Expresa tu creatividad y actitud en el piso de baile con los movimientos enérgicos y urbanos del hip hop.",
    image: images.portfolio_img_4,
  },
  {
    id: 1601,
    title: "Jazz",
    text: "Déjate llevar por la improvisación y el ritmo vibrante del jazz mientras te sumerges en su estilo único y expresivo.",
    image: images.portfolio_img_5,
  },
  {
    id: 1602,
    title: "Contemporáneo",
    text: "Explora la libertad de expresión y la emotividad a través de movimientos fluidos y emotivos en el baile contemporáneo.",
    image: images.portfolio_img_6,
  },
  {
    id: 1603,
    title: "Salsa",
    text: "Siente la alegría y la pasión de la música latina mientras te mueves al ritmo contagioso de la salsa, contagiando a todos con tu energía.",
    image: images.portfolio_img_7,
  },
  {
    id: 1604,
    title: "Bachata",
    text: "Deja que la sensualidad y el romance te guíen en los pasos sensuales y envolventes de la bachata, creando momentos inolvidables en la pista de baile.",
    image: images.portfolio_img_8,
  },
  {
    id: 1605,
    title: "Urbano",
    text: "Libera tu energía y estilo personal en la pista de baile con los movimientos urbanos y contemporáneos del street dance.",
    image: images.portfolio_img_9,
  },
];

const testimonials: Testimonial[] = [
  {
    id: 1903,
    name: "Ayax Rodriguez",
    text: "Con un enfoque dinámico y divertido, guía a los niños a través del emocionante mundo de la danza urbana, enseñándoles movimientos modernos y estilos que conectan con la cultura actual.",
    image: images.customer_img_3,
    rating: 1,
  },
  {
    id: 1906,
    name: "Isaac Maldonado",
    text: "Con su energía y su atención al detalle, guía a sus estudiantes a través de movimientos fluidos y coreografías emocionantes, inspirándolos a explorar la creatividad y la individualidad en cada paso.",
    image: images.customer_img_6,
    rating: 1,
  },
  {
    id: 1908,
    name: "Samuel Irala",
    text: "Con su pasión por la salsa y zumba, Samuel trae la alegría y la energía del Caribe a cada clase, inspirando a sus estudiantes a dejarse llevar por la música y a disfrutar de cada movimiento.",
    image: images.customer_img_8,
    rating: 1,
  },
  {
    id: 1909,
    name: "Pablo Flores",
    text: "Su enfoque meticuloso y su pasión por el arte del baile de salón permiten a los estudiantes dominar tanto la técnica como la gracia necesarias para brillar en la pista de baile.",
    image: images.customer_img_9,
    rating: 1,
  },
  {
    id: 1910,
    name: "Iván Estrella",
    text: "A través de sus enseñanzas, los estudiantes no solo aprenden los pasos y movimientos característicos de la bachata, sino que también se sumergen en la esencia y la emoción de este baile sensual y romántico.",
    image: images.customer_img_10,
    rating: 1,
  },
  {
    id: 1911,
    name: "Uriel Hernandez",
    text: "Su habilidad para enseñar tanto la técnica precisa como la esencia del estilo hace que sus clases sean una experiencia enriquecedora para estudiantes de todos los niveles. Él transforma cada clase en una celebración del ritmo y la cultura latina",
    image: images.customer_img_11,
    rating: 1,
  },
  {
    id: 1912,
    name: "Sandra",
    text: "Con una profunda conexión con la cultura oriental y una precisión técnica impresionante, Sandra guía a sus estudiantes a descubrir la magia del Belly Dance.",
    image: images.customer_img_12,
    rating: 1,
  },
  {
    id: 1913,
    name: "Rebeca Cazares",
    text: "Con una energía contagiosa y una actitud empoderante, nuestra instructora Rebeca, transforma cada clase de Twerk en una explosión de diversión y técnica.",
    image: images.customer_img_13,
    rating: 1,
  },
  {
    id: 1914,
    name: "Cristian Chausse",
    text: "Su pasión por la cultura urbana se refleja en cada clase, donde combina técnica precisa con libertad creativa. Cada lección es una invitación a expresarse, conectar con la música y desafiar los propios límites.",
    image: images.customer_img_14,
    rating: 1,
  },
];

const contact: ContactInfo[] = [
  {
    id: 25,
    icon: <FaPhone style={{ fill: gradient }} />,
    info: "+55 4584 0119",
    text: "¡Llama ya!",
  },
  {
    id: 26,
    icon: <FaWhatsapp style={{ fill: gradient }} />,
    info: "525545840119",
    text: "Whatsapp",
  },
  {
    id: 27,
    icon: <FaEnvelopeOpen style={{ fill: gradient }} />,
    info: "info@mldancestudio.com",
    text: "Escríbenos tus dudas",
  },
  {
    id: 28,
    icon: <FaMapMarkerAlt style={{ fill: gradient }} />,
    info: "ML Dance Studio, Jinetes 105, Calz. de los Jinetes, Las Arboledas, 54026 Tlalnepantla.",
    text: "México, Estado de México",
  },
];

const pricing: Pricing[] = [
  {
    id: 33,
    name: "Paquete 8",
    price: "$1,480.00",
    time: "1 mes",
    image: images.pricing_img_3,
    content: ["2 clases por semana", "8 clases al mes"],
  },
  {
    id: 34,
    name: "Paquete 12",
    price: "$2,160.00",
    time: "1 mes",
    image: images.pricing_img_3,
    content: ["3 clases por semana", "12 clases al mes"],
  },
  {
    id: 35,
    name: "Paquete 16",
    price: "$2,280.00",
    time: "1 mes",
    image: images.pricing_img_3,
    content: ["4 clases por semana", "16 clases al mes"],
  },
];

const privacyPolicy: PrivacyPolicy = {
  title: "AVISO DE PRIVACIDAD DE ML DANCE STUDIO",
  address:
    "AVENIDA DE LOS JINETES 105, COLONIA LAS ARBOLEDAS, TLALNEPANTLA DE BAZ, ESTADO DE MÉXICO, C.P. 54026, MÉXICO",
  email: "monicaluna@mldancestudio.com",
  content:
    "ESTIMADO CLIENTE, en ML DANCE STUDIO CON TODOS LOS DERECHOS RESERVADOS estamos conscientes de la importancia de proteger correctamente los datos personales de nuestros clientes, es por ello y de conformidad con lo establecido en los artículos 15, 16, y demás relativos y aplicables de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), ML DANCE STUDIO CON TODOS LOS DERECHOS RESERVADOS y en lo sucesivo “ML DANCE STUDIO”, con domicilio en AVENIDA DE LOS JINETES 105, COLONIA LAS ARBOLEDAS, TLALNEPANTLA DE BAZ, ESTADO DE MÉXICO, C.P. 54026, MÉXICO, que en su calidad de responsable pone a su disposición el siguiente Aviso de Privacidad, a fin de que tenga pleno conocimiento sobre el tratamiento que se le dará a sus datos personales, así como facilitarle el ejercicio de los derechos que la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) le otorga.",
  sections: [
    {
      title: "I. DATOS PERSONALES TRATADOS",
      content:
        "Los datos personales que recopilamos de nuestros Clientes son: nombre completo, domicilio, teléfonos de contacto y/o contacto de emergencia, CURP, género, correo electrónico y fecha de nacimiento. Asimismo, en el caso de que el Usuario opte por contratar los servicios prestados por “ML DANCE STUDIO”, se recopilará la información referente a la cuenta bancaria, tarjeta de crédito o tarjeta de débito que el Usuario proporcione para tal efecto, así como su RFC, imagen y vídeo de los usuarios que ingresan a las instalaciones y una fotografía para las finalidades señaladas en el siguiente numeral.Cabe mencionar que todos los datos personales antes reseñados son indispensables para que “ML DANCE STUDIO” pueda brindarle a sus clientes los servicios contratados, por lo que, en caso de no aceptar el uso de los mismos para los fines establecidos en el primer párrafo del numeral II. del presente Aviso de Privacidad, “ML DANCE STUDIO” se verá imposibilitado para prestar los servicios ofrecidos. Asimismo, en virtud del carácter necesario de los datos mencionados, para poder prestar dichos servicios, el Usuario declara que es de su conocimiento que en caso de revocación del consentimiento o del ejercicio del derecho de cancelación u oposición para el tratamiento de dichos datos, tendrá lugar, necesariamente, la rescisión del contrato de prestación de servicios que tenga celebrado con “ML DANCE STUDIO”, sin responsabilidad para este último.Trataremos aquellos datos personales y documentos de identificación oficial de menores de edad, proporcionados por padres y/o tutores, con el consentimiento de estos últimos en todos los casos. Los padres y/o tutores podrán ejercer en todo momento los derechos ARCO o revocar el consentimiento para el tratamiento de los datos personales de menores de edad que hubiesen proporcionado para cualquier finalidad relacionada con el plan adquirido o con las actividades de los diversos centros del Responsable siempre y cuando; se acredite que cuenta con las facultades para actuar en calidad de padre, madre o tutor del menor. Finalmente, para garantizar que las actividades de acondicionamiento físico que realice en las instalaciones de “ML DANCE STUDIO” sean las adecuadas a su estado de salud, se podría llegar a recabar información médica de carácter general, a partir de las particularidades presentadas por cada Usuario, así como una carta de diagnóstico clínico en caso de requerirse.",
    },
    {
      title: "II. FINALIDADES DEL TRATAMIENTO",
      content:
        "Sus datos personales son utilizados (tratados) para las siguientes finalidades: (1) suscripción del contrato de servicios, (2) identificación y verificación del registro físico y/o electrónico; (3) contacto a través de distintos medios; entre ellos vía telefónica, chat (WhatsApp), redes sociales y otros; (4) identificación al momento de acceso a las instalaciones; (5) facturación de los servicios contratados; (6) para el correcto manejo de alguna situación de emergencia que requiera de la información con que cuenta “ML DANCE STUDIO” sobre su estado de salud. Asimismo, sus datos personales serán utilizados para las siguientes finalidades comerciales y de promoción: (1) para enviarle información relativa a nuestros servicios, (2) realizar encuestas sobre la calidad de nuestros servicios; (3) Para hacerle llegar ofertas y promociones de “ML DANCE STUDIO”; y (4) Promoción de sorteos, eventos y concursos organizados por “ML DANCE STUDIO”. En caso de que usted no desee que sus datos personales sean tratados para las finalidades comerciales y de promoción antes descritas, usted podrá contactarnos en cualquier momento, para limitar dicho tratamiento, a través de nuestro correo electrónico: monicaluna@mldancestudio.com o directamente en nuestras instalaciones ubicadas en AVENIDA DE LOS JINETES 105, COLONIA LAS ARBOLEDAS, TLALNEPANTLA DE BAZ, ESTADO DE MÉXICO, C.P. 54026, MÉXICO. El usuario proporcionará datos públicos de contacto de una tercera persona, misma que ante cualquier caso de emergencia podrá ser contactado para la atención oportuna a cualquier incidente dentro de las instalaciones. En ese sentido, el usuario manifiesta bajo protesta de decir verdad que ha instruido y autorizado por este tercero para proporcionarnos su información y que cuenta con su consentimiento para que “ML DANCE STUDIO” trate sus datos de conformidad con la finalidad antes mencionada.",
    },
    {
      title: "III. MECANISMOS DE SEGURIDAD",
      content:
        "Para garantizar el correcto resguardo de sus datos personales y para dar pleno cumplimiento a las obligaciones que la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) establece en la materia, se le informa que “ML DANCE STUDIO” tiene implementadas las medidas de seguridad administrativas, técnicas y físicas necesarias y suficientes para la correcta protección de los datos.",
    },
    {
      title: "IV. EJERCICIO DE DERECHOS ARCO",
      content:
        "Usted puede ejercer ante “ML DANCE STUDIO”, en cualquier momento, sus derechos de Acceso, Rectificación, Cancelación y/o Oposición al tratamiento de sus datos personales mediante solicitud por escrito que deberá ser enviada directamente a nuestras instalaciones ubicadas en AVENIDA DE LOS JINETES 105, COLONIA LAS ARBOLEDAS, TLALNEPANTLA DE BAZ, ESTADO DE MÉXICO, C.P. 54026, MÉXICO y/o al correo electrónico: monicaluna@mldancestudio.com incluyendo por lo menos: (a) nombre y domicilio u otro medio para comunicarle la respuesta a su solicitud; (b) los documentos que acrediten su identidad o, en su caso, la representación legal; (c) la descripción clara y precisa de los datos personales respecto de los que se solicita ejercer alguno de los derechos ARCO, (d) la manifestación expresa del derecho (acceso, rectificación, cancelación u oposición) que quiere ejercer sobre tratamiento de sus datos personales; (e) copia de contrato para identificación en el sistema; f) cualquier otro elemento que facilite la localización de los datos personales.",
    },
    {
      title: "V. TRANSFERENCIAS",
      content:
        "En ningún caso “ML DANCE STUDIO” transferirá los datos personales de sus clientes a un tercero, sin el consentimiento previo de los titulares de los mismos salvo en casos donde se requiere la prestación de asistencia médica por emergencia, por lo que se proporcionarán los datos personales sensibles que “ML DANCE STUDIO” posea para la atención a la emergencia por los proveedores de asistencia médica y/o personal designado para tal efecto.",
    },
    {
      title: "VI. CAMBIOS AL AVISO DE PRIVACIDAD",
      content:
        "“ML DANCE STUDIO” se reserva el derecho de cambiar o extender el contenido del presente Aviso de Privacidad en cualquier momento. En caso de que exista algún cambio en este Aviso de Privacidad, se le comunicará a través de nuestras redes sociales y/o vía correo electrónico.",
    },
    {
      title: "VII. CONSENTIMIENTO PARA EL TRATAMIENTO",
      content:
        "Por medio del presente documento consiento el tratamiento de mis datos personales para las finalidades que me han sido informadas por parte de “ML DANCE STUDIO” a través del presente Aviso de Privacidad.",
    },
  ],
  lastUpdated: "Última modificación 01/05/2024.",
};

const regulation: Regulation = {
  title: "REGLAMENTO ACTUALIZADO DE USO DE INSTALACIONES DE ML DANCE STUDIO",
  content:
    "Al hacer uso de las instalaciones de ML DANCE STUDIO, el usuario manifiesta que es su libre voluntad obligarse a acatar en su totalidad los siguientes lineamientos:",
  sections: [
    {
      title: "1. USO DE LAS INSTALACIONES",
      content: [
        "1.1 El ingreso a las instalaciones se hará sin excepción, exhibiendo la credencial al momento de entrar a las instalaciones, misma que fue otorgada al momento de la inscripción al titular del contrato por ML DANCE STUDIO.",
        "1.2 Todos los usuarios deberán portar ropa y calzado adecuado y funcional para la práctica de actividades físicas, motivo por el cual no se permite estar sin playera o camiseta dentro de las instalaciones.",
        "1.3 Está prohibido azotar, arrojar y dar uso inadecuado a los equipos, accesorios y/o instalaciones. En caso de ocasionar daño a los equipos o a las instalaciones del Estudio de Baile por uso indebido del equipo, la reparación o reposición de los mismos deberá ser cubierta por el usuario en su totalidad, con independencia a las medidas determinadas por ML DANCE STUDIO.",
        "1.4 El usuario deberá evitar tener acciones que perturben la tranquilidad de los demás.",
        "1.5 No se permite comercializar, ni ofrecer ningún tipo de producto o servicio dentro de las instalaciones de ML DANCE STUDIO.",
        "1.6 Está prohibido hacer uso de las instalaciones del Estudio de baile para repartir volantes, folletos, piezas promocionales, cupones, demostración de mercancías y cualquier tipo de actividad lucrativa o publicidad personal, colectas o donativos para cualquier causa, salvo que medie autorización por escrito por parte de ML DANCE STUDIO.",
        "1.7 Los usuarios deberán conducirse de manera respetuosa hacia el Staff, Maestras, Maestros, usuarios e invitados, motivo por el cual se prohíben los gritos, uso de palabras altisonantes, así como, cualquier agresión física o verbal dentro de las instalaciones.",
        "1.8 No está permitido ingerir alimentos en ninguno de los salones de las instalaciones de ML DANCE STUDIO.",
        "1.9 No se permite el ingreso de mascotas a las instalaciones ni dejarlas en el área de recepción mientras se realizan las actividades físicas, salvo que se trate de mascotas de asistencia, en el cual deberán de cumplir con los requisitos establecidos para la permanencia del animal en el Estudio de Baile.",
        "1.10 No se permite el ingreso de acompañantes de usuarios que no se encuentren inscritos en un plan de ML DANCE STUDIO, salvo que se trate de personas de asistencia o ayuda médica siempre y cuando, cumpla con los requisitos establecidos para tales efectos, así como en el caso de los menores de edad que deberán estar acompañados de un padre, madre o tutor debidamente acreditado.",
        "1.11 No se permite dejar objetos personales en los salones de baile, areas de uso común, muebles del Estudio de Baile; ya que en caso de extravío ML DANCE STUDIO no será responsable por los mismos.",
        "1.12 Queda prohibido para los usuarios obstaculizar el uso de las instalaciones con conductas contrarias a esta disposición como mantenerse en los salones de baile finalizada la clase del plan contratado y/o accesorios impidiendo que otro(s) pueda(n) utilizarlos.",
      ],
    },
    {
      title: "2. SEGURIDAD",
      content: [
        "2.1 Está prohibido fumar, ingresar o ingerir cualquier tipo de bebidas alcohólicas, drogas, estupefacientes, vapeador o cualquier enervante dentro de las instalaciones.",
        "2.2 Se negará el acceso a usuarios que pretendan ingresar a las instalaciones con aliento alcohólico o que se presuma se encuentran bajo la influencia de drogas.",
        "2.3 Ningún usuario podrá ingresar a las instalaciones portando armas u objetos punzocortantes.",
        "2.4 QUEDA PROHIBIDO FILMAR O FOTOGRAFIAR CON CÁMARA O DISPOSITIVO, MÓVIL O ELECTRÓNICO LAS CLASES DE BAILE, A OTROS USUARIOS, PERSONAL DE ML DANCE STUDIO, SIN EL DEBIDO CONSENTIMIENTO ESCRITO, EXPRESO O TÁCITO DE LOS MISMOS Y DE ML DANCE STUDIO. ASIMISMO, QUEDA PARCIALMENTE PERMITIDO AL USUARIO TOMAR FOTOGRAFÍAS Y/O VÍDEO, SIEMPRE Y CUANDO, ÉSTAS NO SEAN DE CARÁCTER SEXUAL Y/O QUE DESACREDITEN A LA MARCA.",
        "2.5 Se prohíbe realizar acciones fuera de las actividades físicas propias del Estudio de Baile que puedan dañar o poner en peligro a los usuarios y/o personal de ML DANCE STUDIO, tales como correr, jugar entre usuarios o con el mobiliario de las instalaciones.",
        "2.6 Durante el uso de las instalaciones, el usuario tendrá a su disposición el uso de casilleros, debiendo utilizar en todo momento un candado de seguridad tamaño mínimo 50 x 40mm, de forma cilíndrica y de llave (no candado de combinación) para el resguardo de sus pertenencias. Las pertenecías deberán ser retiradas al término de su estancia en la unidad, por lo que ML DANCE STUDIO podrá desalojar los casilleros una vez culmine el horario de operación de la unidad, deslindando de cualquier responsabilidad por la apertura de casilleros posterior al cierre.",
        "2.7 En caso de robo a casillero, siempre y cuando el usuario haya colocado el candado de seguridad que especifica el punto anterior y el casillero y/o candado tengan señas de violencia; ML DANCE STUDIO compensará el valor de los bienes por un máximo de $500.00 (Quinientos pesos 00/100 M.N.) cantidad que será abonada a las mensualidades siguientes, lo anterior en el entendido de que el robo deberá ser reportado de manera inmediata en recepción. Para lo anterior, el usuario deberá exhibir copia de la denuncia correspondiente gestionada ante el Ministerio Público y acreditar la propiedad de sus pertenencias, motivo por el cual deberá hacerlo a título personal.",
        "2.8 Será responsabilidad del usuario todos los objetos de valor que lleve consigo. Por lo anterior ML DANCE STUDIO no será responsable por objetos de valor perdidos.",
        "2.9 El staff, maestras y maestros tienen prohibido resguardar objetos personales en recepción, incluyendo medios de transporte como bicicletas (aún plegables), patinetas, patines, deslizadores eléctricos y similares, así como accesorios de los mismos, motivos por el cual el usuario no deberá insistir.",
        "2.10 Todos los usuarios manifiestan que su estado de salud es óptimo para realizar actividades físicas, eximiendo a ML DANCE STUDIO de cualquier responsabilidad derivada de dicha manifestación en caso de ser falsa, asimismo, deberán realizar por su cuenta, de manera periódica las evaluaciones médicas necesarias para verificar que su salud se mantenga en buen estado.",
        "2.11 Los usuarios que requieran hacer uso de las instalaciones con algún tipo de muletas, yeso, y/o alguna otra dificultad no podrán hacer uso de las instalciones por su propia seguridad. Y el plan continuará corriendo tal y como fue contratado.",
      ],
    },
    {
      title: "3. HIGIENE",
      content: [
        "3.1 Queda estrictamente prohibido el uso o desecho de jeringas en cualquier área del estudio de baile, así como suministrar de manera oral o inyectar a otros usuarios cualquier tipo de sustancias, en caso de necesitar aplicarse alguna sustancia por indicaciones médicas deberá suministrarse de manera previa al ingreso a las instalaciones.",
        "3.2 El lavabo es de uso exclusivo para el aseo de las manos, queda prohibido depilarse o lavarse el cabello o distintas partes del cuerpo en ellos.",
        "3.3 Sin excepción alguna el uso del sanitario será individual.",
        "3.4 Será obligación del usuario procurar buenas prácticas de higiene dentro de las instalaciones.",
      ],
    },
    {
      title: "4. MENORES DE EDAD",
      content: [
        "4.1 Los menores de edad a partir de 12 años podrán hacer uso de las instalaciones, presentando copia simple su acta de nacimiento, CURP y alguna identificación con fotografía del menor al momento de inscribirse y hacerlo en compañía de un padre, madre o tutor quien firmará el contrato y reglamento de dicho menor, obligándose al cumplimiento de todos los términos y condiciones de dichos documentos. En caso de ser tutor legal, deberá de acreditar la tutoría legal con la resolución correspondiente.",
        "4.2 Se prohíbe la entrada a las instalaciones a menores de 12 años, ni permanecer en recepción o permanecer más de quince minutos después de concluida su clase de baile.",
        "4.3 El padre, madre o tutor manifiesta que, ante cualquier falta al reglamento por parte del menor, la notificación de los hechos se hará a través del correo electrónico señalado en el contrato de servicios o bien al recoger al menor de edad de las instalaciones de ML DANCE STUDIO.",
      ],
    },
    {
      title: "5. HORARIOS",
      content: [
        "5.1 El horario de las Instalaciones de ML DANCE STUDIO es de 7:00 horas a 23:00 horas de Lunes a Domingo.",
        "5.2 Despúes de concluir su clase del plan contratado, el usuario no puede permanecer más de quince minutos posteriores a concluir su clase.",
      ],
    },
    {
      title: "6. CLASES GRUPALES",
      content: [
        "Durante las clases de baile; el usuario se obliga a atender los siguientes lineamientos específicos para dicha actividad de manera adicional a los enumerados en los rubros anteriores.",
        "6.1 No se permite ingerir ningún tipo de alimentos en el área designada para dichas clases.",
        "6.2 El salón o áreas designadas con las que cuente ML DANCE STUDIO, es para uso de clases grupales en los horarios previamente establecidos. Estas áreas podrán ser utilizadas por los usuarios cuando así lo autorice el personal de ML DANCE STUDIO quedando estrictamente prohibido que el usuario manipule o haga uso del equipo audiovisual.",
        "6.3 No está permitido durante la clase el uso de dispositivos electrónicos como tabletas electrónicas, computadoras, celulares, o cualquier otro dispositivo electrónico que pueda distraer a los usuarios o profesores para el desarrollo adecuado de la clase.",
        "6.4 No se permite ingresar mancuernas, pesas o algún otro objeto o accesorio deportivo al salón de clases, salvo que el profesor que imparte la clase dé la instrucción especifica al respecto.",
        "6.5 Las clases están sujetas a un cupo limitado, mismo que será indicado por el personal de ML DANCE STUDIO, queda prohibido apartar el lugar o indicar que necesitan cierta cantidad de lugares, el acceso y cupo serán de acuerdo al arribo de cada usuario.",
        "6.6 Los horarios de las clases, así como los profesores están sujetos a cambios de acuerdo a las necesidades y disponibilidad de ML DANCE STUDIO por lo que de manera diaria se indicaran a la entrada del salón las actividades del día.",
      ],
    },
    {
      title: "7. SANCIONES",
      content: [
        "7.1 En caso de incumplimiento a cualquiera de los puntos antes señalados, el usuario se hará acreedor a una amonestación por escrito, en caso de reincidencia su plan se rescindirá de manera inmediata, en el entendido de que la rescisión no implica que el usuario quede eximido de las cantidades adeudadas que deba cubrir al momento de la baja por concepto de pena convencional por cancelación anticipada, y en su caso anualidad o mensualidad, según sea el caso.En el supuesto de cometer una falta grave la baja se dará de manera inmediata sin amonestación previa, considerando como faltas graves las siguientes:",
        "7.1.1 Agresión física o verbal en contra de otros usuarios, invitados, staff, maestras o maestros dentro de las instalaciones de ML DANCE STUDIO.",
        "7.1.2 Cualquier tipo de comportamiento que altere el orden y/o la operación de las instalaciones de ML DANCE STUDIO.",
        "7.1.3 Detectar en redes sociales fotografías o videos tomados en las instalaciones de ML DANCE STUDIO y no cubran con lo estipulado en el presente reglamento.",
        "7.1.4 Realizar actos o tener encuentros sexuales así como, conductas de acoso hacia otros usuarios, staff, maestras y maestros.",
        "7.1.5 Hacer uso indebido de los espacios comunes, considerando en ellos las de uso individual o que sean ocupados incorrectamente por más de una persona al mismo tiempo; tales como baños, lockers y/o cualquier área pública.",
        "7.1.6 Ser sorprendido por usuarios, staff, maestras o maestros, utilizando o desechando jeringas o ayudando a otro usuario a hacer uso de ellas.",
        "7.1.7 Quejas de usuarios, staff, maestras o maestros, reportando faltas de respeto a su persona, privacidad o impedir el uso de los equipos o instalaciones.",
        "7.1.8 Proporcionar a ML DANCE STUDIO información incorrecta, falsa o imprecisa para obtener la prestación de los servicios objeto del presente reglamento.",
        "7.1.9 Contar con un plan anterior que tenga algún adeudo o que cuente con antecedentes de incumplimiento al reglamento.",
        "Las políticas del presente Reglamento de uso de las instalaciones, son aplicables para todos los Usuarios, Staff, Maestras o Maestros de los servicios que proporciona ML DANCE STUDIO y están obligados al cumplimiento de estos en todo momento.",
      ],
    },
    {
      title: "IMPORTANTE",
      content: [
        "A) ML DANCE STUDIO NO DISCRIMINA A NADIE POR MOTIVOS DE RAZA, RELIGIÓN, GÉNERO, ORIENTACIÓN SEXUAL, NACIONALIDAD, CONDICIÓN FÍSICA O SOCIOECONÓMICA NI POR NINGUNA OTRA PARTICULARIDAD.",
        "B) AL MOMENTO DE INSCRIBIRSE A ML DANCE STUDIO, FIRMAR EL CONTRATO NECESARIO, ASÍ COMO EL PRESENTE DOCUMENTO, EL USUARIO MANIFIESTA SU VOLUNTAD PARA OBLIGARSE AL MISMO EN TODOS LOS TÉRMINOS Y CONDICIONES, SIN QUE MEDIE ALGÚN VICIO DE LA VOLUNTAD.",
        "C) AL INSCRIBIRSE EL USUARIO CONSIENTE EL USO DE SU IMAGEN, ASÍ COMO LA DIFUCIÓN DE LA MISMA POR CUALQUIER MEDIO EN MATERIALES EN LOS CUALES ML DANCE STUDIO PROMUEVA Y DIVULGUE SUS SERVICIOS. SIN TENER ML DANCE STUDIO POR ESTO NINGUNA RESPONSABILIDAD HACÍA EL USUARIO.",
        "D) EL VALOR DE LAS MENSUALIDADES Y/O CUOTA DE MANTENIMIENTO ANUAL SERÁ COBRADO EN EL DÍA ESTABLECIDO EN EL CONTRATO, LOS CUALES PODRÁN TENER UN REAJUSTE ANUAL.",
      ],
    },
  ],
  lastUpdated: "Última modificación 01/05/2024.",
};

const sections: Sections = {
  services,
  about,
  qualities,
  features,
  portfolio,
  testimonials,
  contact,
  pricing,
  privacyPolicy,
  regulation,
};

export default sections;
